import React, { ReactNode } from "react"
import { Box, Image } from "@chakra-ui/react"
import frameImage from "assets/images/phone/frame.png"

export const PHONE_WIDTH = 430
export const PHONE_FULL_HEIGHT = 888
export const PHONE_SCREEN_INSET = 13
export const PHONE_SCREEN_WIDTH = PHONE_WIDTH - 2 * PHONE_SCREEN_INSET
export const PHONE_SCREEN_CORNER_RADIUS = 46
export const PHONE_STATUS_BAR_HEIGHT = 60
export const PHONE_HOME_INDICATOR_HEIGHT = 34
export const PHONE_FRAME_INSET = 4
const PHONE_FRAME_RADIUS = 54

type Props = {
  children: ReactNode
  /** Shorter than PHONE_FULL_HEIGHT crops the phone at the bottom. */
  height?: number
}

const Phone = ({ children, height = 530 }: Props) => {
  const isFullHeight = height >= PHONE_FULL_HEIGHT

  return (
    <Box
      position="relative"
      w={`${PHONE_WIDTH}px`}
      h={`${Math.min(height, PHONE_FULL_HEIGHT)}px`}
      overflow="hidden"
    >
      <Box
        position="absolute"
        top={`${PHONE_FRAME_INSET}px`}
        left={`${PHONE_FRAME_INSET}px`}
        right={`${PHONE_FRAME_INSET}px`}
        bottom={isFullHeight ? `${PHONE_FRAME_INSET}px` : 0}
        borderTopRadius={`${PHONE_FRAME_RADIUS}px`}
        borderBottomRadius={isFullHeight ? `${PHONE_FRAME_RADIUS}px` : 0}
        overflow="hidden"
      >
        {children}
      </Box>
      <Image
        src={frameImage}
        position="absolute"
        top={0}
        left={0}
        w="100%"
        zIndex={1}
        pointerEvents="none"
        alt=""
      />
    </Box>
  )
}

export default Phone
